import IEO from "../../components/Olympiad/ClassThree/IEO";
import IGKO from "../../components/Olympiad/ClassThree/IGKO";
import IMO from "../../components/Olympiad/ClassThree/IMO";
import NSO from "../../components/Olympiad/ClassThree/NSO";

// Define the type for menu items
interface MenuItem {
    url: string;
    title: string;
    component?: React.FC; // Optional React functional component
    subMenu?: MenuItem[]; // Allow subMenu to be an array of MenuItem
}

const topics: MenuItem[] = [
    { url: "/olympiad-classthree/nso", title: "National Science Olympiad (NSO)", component: NSO },
    { url: "/olympiad-classthree/imo", title: "International Mathematics Olympiad (IMO)", component: IMO },
    // { url: "/olympiad-classthree/nco", title: "National Cyber Olympiad (NCO)", component: NCO },
    { url: "/olympiad-classthree/igko", title: "International General Knowledge Olympiad (IGKO)", component: IGKO },
    { url: "/olympiad-classthree/ieo", title: "International English Olympiad (IEO)", component: IEO },
    // { url: "/olympiad-classthree/nstse", title: "National-level Science Talent Search Examination (NSTSE)" }
];

export default topics;